import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=122b7daf&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=122b7daf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122b7daf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('122b7daf')) {
      api.createRecord('122b7daf', component.options)
    } else {
      api.reload('122b7daf', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=122b7daf&scoped=true&", function () {
      api.rerender('122b7daf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2tCSgwwHD1ZS6/JS/comp/CookieBox.vue"
export default component.exports